import { archetypes } from "@/mocks/crash";
import SectionHeading from "./SectionHeading";

export default function ArchetypeFiles() {
  return (
    <section id="types" className="relative bg-paper-50 py-16 md:py-24 scroll-mt-16">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="ARCHETYPE FILES · 塌房档案"
            title="四类最容易『塌』的人设"
            desc="人设分很多种，但塌房的高发区高度相似。看懂这些经典剧本的构造与死穴，你就能在人设还没塌之前，先看穿滤镜。"
          />
          <p className="lg:text-right text-sm text-ink-700/60 leading-relaxed max-w-sm">
            标注为 <i className="ri-error-warning-line text-coral-600 align-middle"></i>{" "}
            的部分，是每类人设最常被戳穿的典型裂缝。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {archetypes.map((a, i) => (
            <article
              key={a.name}
              className="group flex flex-col overflow-hidden rounded-2xl border border-paper-200 bg-paper-100/60 hover:bg-paper-50 transition-colors"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={a.img}
                  alt={`${a.name}（${a.en}）人设崩塌档案配图`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 right-3 font-display text-5xl text-paper-50/80 drop-shadow">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute bottom-3 left-3 inline-flex items-center gap-2 rounded-full bg-paper-50/90 px-3 py-1.5 text-ink-900">
                  <i className={`${a.icon} text-coral-600`}></i>
                  <span className="font-semibold">{a.name}</span>
                  <span className="text-xs text-ink-700/55">{a.en}</span>
                </span>
              </div>

              <div className="flex flex-col p-5 md:p-6">
                <p className="text-ink-700/85 leading-relaxed text-sm">
                  <strong className="text-ink-900 font-semibold">人设剧本：</strong>
                  {a.note}
                </p>
                <div className="mt-4 rounded-xl border-l-2 border-coral-500 bg-coral-50 px-4 py-3.5">
                  <p className="text-sm text-ink-800 leading-relaxed">
                    <strong className="inline-flex items-center gap-1 text-coral-700 font-semibold">
                      <i className="ri-error-warning-line"></i> 崩塌点：
                    </strong>
                    {a.collapse}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}